/**
 * Color-pin markers (the original 5 colored pin sprites). Iterated by the UI
 * when rendering the small color-circle swatches.
 */
export const MAP_NOTE_PIN_COLORS = ["white", "red", "blue", "green", "yellow"];
/**
 * Banner-style markers. They share the marker selection UI with the colored
 * pins but render as full sprites instead of solid color swatches.
 */
export const MAP_NOTE_PIN_BANNERS = [
    "banner",
    "banner-skull",
    "banner-star",
    "banner-swords",
    "banner-tent",
    "banner-tower",
];
/** All marker identifiers a map note can use. */
export const MAP_NOTE_PIN_MARKERS = [
    ...MAP_NOTE_PIN_COLORS,
    ...MAP_NOTE_PIN_BANNERS,
];
export const DEFAULT_MAP_NOTE_PIN_COLOR = "white";
/**
 * Maps each marker to the system-catalog overlay id of the corresponding
 * sprite asset. These overlay ids live in the production "Pins" overlay pack
 * and are loaded through the same catalog pipeline used for decorations.
 */
export const MAP_NOTE_PIN_OVERLAY_ID = {
    white: "overlay_bb5df8c9-67f4-4fa8-88b3-99c9abc3549b",
    red: "overlay_29d00955-8218-405f-a183-6d9ead2d8fc2",
    blue: "overlay_62112060-997a-4d19-ad21-8418adad6a35",
    green: "overlay_a017a450-0f7a-49fc-a994-232c4e720593",
    yellow: "overlay_70ab1b47-eb43-4487-ba29-152dda9d88e8",
    banner: "overlay_c146199e-e110-45a8-9b36-93708339cf8e",
    "banner-skull": "overlay_d20626db-4885-40e5-ba82-af5879c19ff7",
    "banner-star": "overlay_8246e788-71a5-4a41-aa35-979fdfe9e764",
    "banner-swords": "overlay_abe6fb3e-6c27-4dd5-b39f-620c65a9d689",
    "banner-tent": "overlay_37adfc76-7d9b-4510-a6fe-58c8530863eb",
    "banner-tower": "overlay_8187b392-cbd2-4602-bf7c-f622e5994003",
};
/**
 * CSS hex colors used by the small swatch UI for the color-pin variants. Only
 * defined for the colored pins; banners do not have a single representative
 * solid color and instead render as full sprites in the marker picker. Typed
 * as a partial map over all markers so callers can safely look up arbitrary
 * marker ids and fall back when no swatch color exists.
 */
export const MAP_NOTE_PIN_HEX_COLORS = {
    white: "#f5f5f5",
    red: "#d44343",
    blue: "#3a6fb0",
    green: "#3f8a4a",
    yellow: "#e5b94b",
};
/** Human-readable label for a swatch tooltip. */
export const MAP_NOTE_PIN_COLOR_LABEL = {
    white: "White",
    red: "Red",
    blue: "Blue",
    green: "Green",
    yellow: "Yellow",
    banner: "Banner",
    "banner-skull": "Banner (skull)",
    "banner-star": "Banner (star)",
    "banner-swords": "Banner (swords)",
    "banner-tent": "Banner (tent)",
    "banner-tower": "Banner (tower)",
};
export function isMapNotePinColor(value) {
    return (typeof value === "string" &&
        MAP_NOTE_PIN_MARKERS.includes(value));
}
export function isMapNotePinBanner(value) {
    return MAP_NOTE_PIN_BANNERS.includes(value);
}
